import {Recipient} from './Recipient';
import {Tag} from './Tag';

export enum MessageState {
    ALL = 'ALL',
    ALL_WITHOUT_ACKNOWLEDGEMENT = 'ALL_WITHOUT_ACKNOWLEDGEMENT',
    ALL_WITH_ACKNOWLEDGEMENT = 'ALL_WITH_ACKNOWLEDGEMENT',
    COMPLETED_UNRESPONSIVE = 'COMPLETED_UNRESPONSIVE',
    IN_PROGRESS_ESCALATED_NEXT_TIER = 'IN_PROGRESS_ESCALATED_NEXT_TIER'
}

export class MessagePreviewResult {
    response?: string;
    sent?: string;
    elapsedTime?: string;
    recipients?: Partial<Recipient>[];
    from?: string;
    message?: string;
}

export class MessagePreviewTableResult extends MessagePreviewResult {
    appId?: string;
}

export class Message {
    id: string;
    sent: string;
    from: string;
    message: string;
    detail: string;
    call_bridge: string;
    pin: string;
    ticket: string;
    chatroom: string;
    recipients: Recipient[];
    template_id: number;
    template_name: string;
    alert: boolean;
    parent_id: number;
    application_names: any[];
    client_names: any[];
    sent_by: string;
    tags: Tag[];
}
